<template>
  <div class="classic-search-website" v-loading="isLoading" loading-text="数据加载中...">
    <!-- 第一区域：顶部公司信息 -->
    <!-- 网站顶部的component共用模块引入 -->
    <atop ref="atop"></atop>
    
    <!-- 第二区域：全站搜索区。具备搜索标签，该点内容和其他页面不同 -->
    <section class="search-section">
      <div class="container search-container">
        <div class="search-box classic-border">
          <div class="search-icon">
            <!-- <i class="el-icon-search"></i> -->
            <i class="fas fa-search"></i>
          </div>
          <el-input
            v-model="searchKeyword"
            class="search-input"
            placeholder="请输入书名、正文内容等关键词进行检索..."
            @keyup.enter.native="handleSearch"
          />
          <el-button class="search-button" @click="handleSearch">搜索</el-button>
        </div>
        <div class="search-tags">
          <span 
            v-for="tag in searchTags" 
            :key="tag"
            class="search-tag"
            @click="handleTagClick(tag)"
          >
            {{ tag }}
          </span>
          <span class="search-tag more-tag" @click="showTagsModal = true">更多...</span>
        </div>
      </div>
    </section>
    
    <!-- 第三区域：搜索结果区 -->
    <section class="main-section">
      <div class="container">
        <!-- 移动端书籍分类折叠按钮,本界面无该内容，代码备用 -->
        <!-- <button 
          class="mobile-categories-toggle" 
          @click="toggleMobileCategories"
          v-if="isMobile"
        >
          <div class="toggle-icon" :class="{ expanded: showMobileCategories }" id="toggleIcon">
            <i class="fas" :class="showMobileCategories ? 'fa-chevron-right' : 'fa-bars'"></i>
          </div>
          <span>书籍分类</span>
          <div></div>
        </button> -->
        
        <!-- 搜索结果标题 -->
        <div class="search-result-header">
          <div class="search-result-header-left">
            <div>
              <div class="search-title"><span style="cursor: pointer;" @click="goBackPage">&lt;上页</span>&nbsp;-&nbsp;搜索内容：<span class="search-keyword">"{{ currentKeyword }}"</span></div>
              <p style="margin-top: 5px; color: #5c3a21;font-family: 'Noto Serif SC', serif;">共找到<span style="color: #a0522d; font-weight: 700;"> {{ totalBookNums }} </span>本相关书籍</p>
            </div>
          </div>
          <div class="search-count">{{ currentCategory }}</div>
        </div>
        
        <!-- 搜索结果展示区 -->
        <div class="search-results-container">
          <!-- 搜索结果列表 -->
          <div 
            v-for="book in searchResults" 
            :key="book.id"
            class="search-result-item"
          >
            <div class="book-cover-result"  style="cursor: pointer;" @click="handleBookClick(book)">
              <img :src="book.cover" :alt="book.title">
            </div>
            <div class="book-info">
              <div class="book-title-row">
                <div class="book-name" v-html="formatTitle(book.title)"></div>
                <!-- <div class="keyword-count">{{ book.keywordCount }}{{ book.keywordCount === 10 ? '+' : '' }}</div> -->
                <div class="keyword-count">{{ book.keywordCount > 10 ? '10+' : book.keywordCount }}</div>
              </div>
              <div class="book-meta-grid">
                <div class="meta-item">
                  <span class="meta-label">I S B N:</span>
                  <span class="meta-value">{{ book.isbn }}</span>
                </div>
                <div class="meta-item right-align">
                  <span class="meta-label">编 著:</span>
                  <span class="meta-value">{{ book.author }}</span>
                </div>
                <div class="meta-item">
                  <span class="meta-label">出版社:</span>
                  <span class="meta-value">{{ book.publisher }}</span>
                </div>
                <div class="meta-item right-align">
                  <span class="meta-label">装帧开本:</span>
                  <span class="meta-value">{{ book.format }}</span>
                </div>
                <div class="meta-item">
                  <span class="meta-label">出版日期:</span>
                  <span class="meta-value">{{ book.publishDate }}</span>
                </div>
                <div class="meta-item right-align">
                  <span class="meta-label">定 价:</span>
                  <span class="meta-value price">{{ formatPrice(book.price) }}</span>
                </div>
              </div>
              <div class="book-description two-line-description" v-html="formatDescription(book.description)"></div>
            </div>
          </div>
          
          <!-- 分页 - 完全按照原HTML结构 -->
          <div class="pagination">
            <div 
              class="pagination-prev" 
              :class="{ disabled: currentPage === 1 }"
              @click="prevPage"
            >
              上一页
            </div>
            <ul class="pagination-list">
              <li 
                v-for="(page, index) in pageNumbers" 
                :key="index"
                class="pagination-item"
                :class="{ active: page === currentPage }"
                @click="page !== '...' && goToPage(page)"
              >
                {{ page === '...' ? '...' : page }}
              </li>
            </ul>
            <div 
              class="pagination-next" 
              :class="{ disabled: currentPage === totalPages }"
              @click="nextPage"
            >
              下一页
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 第四区域：页脚 -->
    <!-- 网站页脚的component共用模块引入 -->
    <abottom ref="abottom"></abottom>
    
    <!-- 更多分类弹出层 -->
    <div class="modal-overlay" v-if="showTagsModal" @click="showTagsModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h2 class="modal-title">更多分类</h2>
          <button class="close-btn" @click="showTagsModal = false">&times;</button>
        </div>
        <div class="modal-tags">
          <div 
            v-for="tag in additionalTags"
            :key="tag"
            class="modal-tag"
            @click="handleModalTagClick(tag)"
          >
            {{ tag }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getBookOneType, getSearchBook} from '../../api/home'
import { developmentUrl } from "../../config/env";

export default {
  name: 'ClassicSearchWebsite',
  data() {
    return {
      searchKeyword: this.$route.query.searchtext,
      currentKeyword: this.$route.query.searchtext,
      searchKeywordTrad: '',  //简体文字搜索关键词变化为繁体文字搜索的关键词

      currentCategory: '全部',   //搜索标签默认值，此处值如修改后台服务接口需相应修改
      showMobileCategories: false,
      showTagsModal: false,
      isMobile: false,
      currentPage: 1,
      pageSize: 10,
      categories: [],
      searchTags: ['全部', '书名', '正文'],    //搜索标签范围值，此处值如修改后台服务接口需相应修改
      additionalTags: [],
      // searchResults: [
      //   {
      //     id: 1,
      //     title: '明代基本史料丛刊·奏折（疏）卷',
      //     cover: require('@/assets/bookpic/book13.jpg'),
      //     isbn: '9787512037663',
      //     author: '卞甫',
      //     publisher: '蝠池书院',
      //     format: '精装 1/16',
      //     publishDate: '2019年9月',
      //     price: 51000.00,
      //     keywordCount: 10,
      //     description: '本书详细记述了明朝开国皇帝朱元璋的一生，是跌宕起伏又光辉灿烂的一生，从其贫苦出身到建立大明王朝的全过程。书中深入分析了朱元璋的政治手腕、军事才能以及治国理念，揭示了这位传奇皇帝如何从一个放牛娃成长为一代帝王。本书全面的呈现...'
      //   }
      // ],
      searchResults: [],
      totalBookNums: 0,
      isLoading: false
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalBookNums / this.pageSize)
    },
    /*
    paginatedResults() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.searchResults.slice(start, end)
    },
    */
    pageNumbers() {
      // return [1, 2, 3, 4, 5, '...', 12]        //20260108,分页中的省略号...前面的页码数字
      let totalnums = this.totalBookNums / this.pageSize;
      let pagenoArr = [];
      for(let i=1;i<totalnums+1;i++){
        pagenoArr.push(i);
      }
      return pagenoArr;
    }
  },
  mounted() {
    this.checkScreenWidth()
    window.addEventListener('resize', this.checkScreenWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth)
  },

  //初始化获取网络数据
  created() {
    this.GetBookOneType();
    this.GetSearchBook();
  },
  
  methods: {
    //获取书籍一级分类服务数据
    GetBookOneType(){
      let queryParams = {};
      getBookOneType(queryParams).then(response => {
        this.categories = response.data.data;
        console.log(this.categories);
        for(let i=0;i<this.categories.length;i++){
          if(i<5){
            this.searchTags.push(this.categories[i].typename);
          }
          else{
            this.additionalTags.push(this.categories[i].typename);
          }
        }
      })
    },

    //获取meilisearch搜索的结果
    GetSearchBook(){
      this.isLoading = true;
      let queryParams = {};
      queryParams.pageNum = this.currentPage;
      queryParams.pageSize = this.pageSize;
      queryParams.content = this.searchKeyword;
      queryParams.onetypename = this.currentCategory;
      getSearchBook(queryParams).then(response => {
        this.searchResults = [];
        let listdata = [];
        listdata = response.data.rows;
        this.totalBookNums = response.data.maprowdata.total_documents;
        this.searchKeywordTrad = response.data.maprowdata.tradSearchtext;
        
        for(let i=0;i<listdata.length;i++){
          let onemap = {};
          onemap.id = listdata[i].id;
          onemap.title = listdata[i].title;
          // console.log("cover===" + listdata[i].cover); 
          let pictureStr = listdata[i].cover.replace(/^\["/, '').replace(/"\]$/, '');     //去掉数据库中存储的两边的 ["  和 "]
          onemap.cover = developmentUrl + pictureStr.substring(1);
          onemap.isbn = listdata[i].isbn;
          onemap.author = listdata[i].author;
          onemap.publisher = listdata[i].publisher;
          onemap.format = listdata[i].format;
          onemap.publishDate = listdata[i].publishDate;
          onemap.price = listdata[i].price;
          onemap.keywordCount = listdata[i].keywordCount;
          onemap.description = listdata[i].description;

          onemap.bookpartid = listdata[i].bookpartid;
          onemap.bookpageno = listdata[i].bookpageno;
          onemap.pagenoint = listdata[i].pagenoint;

          this.searchResults.push(onemap);
        }

        this.isLoading = false;
      })
    },

    checkScreenWidth() {
      this.isMobile = window.innerWidth <= 768
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        // 20260314，方案一：搜索当前页面搜索，点击进入下级页面返回后，返回到最初的首页的搜索关键字页面
        /*
        this.currentKeyword = this.searchKeyword
        this.GetSearchBook();
        */
        // 20260314，方案二：搜索当前页面搜索，点击进入下级页面返回后，返回到当前最新的搜索关键字页面
        // window.location.href = `/searchpage?type=1&searchtext=${this.searchKeyword}`;     //会产生多个搜索的界面
        window.location.replace(`/searchpage?type=1&searchtext=${this.searchKeyword}`)
      } else {
        this.$message({
          message: '请输入搜索关键词',
          type: 'warning'
        })
      }
    },
    handleTagClick(tag) {
      // this.currentKeyword = tag
      this.currentCategory = tag
      // this.$message({
      //   message: `正在按"${tag}"分类进行搜索`,
      //   type: 'info'
      // })
      this.GetSearchBook();
    },
    handleModalTagClick(tag) {
      // this.currentKeyword = tag
      this.currentCategory = tag
      this.showTagsModal = false
      // this.$message({
      //   message: `正在按"${tag}"分类进行搜索`,
      //   type: 'info'
      // })
      this.GetSearchBook();
    },
    
    /*不考虑输入简体字变化为繁体字的搜索方式，仅简体字搜索的功能代码备份
    formatDescription(description) {
      // 确保搜索词能被正确高亮currentCategory
      const keyword = this.currentKeyword
      if (keyword && this.currentCategory != '书名') {
        const regex = new RegExp(keyword, 'g')
        return description.replace(regex, '<span class="keyword-highlight">$&</span>')
      }
      return description
    },
    formatTitle(title) {
      const keyword = this.currentKeyword
      if (keyword  && this.currentCategory != '正文') {
        const regex = new RegExp(keyword, 'g')
        return title.replace(regex, '<span class="keyword-highlight">$&</span>')
      }
      return title
    },
    */
    // 输入简体字变化为繁体字，一起简体和繁体搜索的代码实现********************************begin
    // 返回接口中获取繁体字，判断不为空的时候，修改下面两个高亮显示的函数，先相同方法处理繁体字，再简体字
    formatDescription(description) {
      // 确保搜索词能被正确高亮currentCategory
      const keywordTrad = this.searchKeywordTrad;
      if (keywordTrad && this.currentCategory != '书名') {
        const regex = new RegExp(keywordTrad, 'g')
        description = description.replace(regex, '<span class="keyword-highlight">$&</span>')
      }

      const keyword = this.currentKeyword
      if (keyword && this.currentCategory != '书名') {
        const regex = new RegExp(keyword, 'g')
        return description.replace(regex, '<span class="keyword-highlight">$&</span>')
      }
      return description
    },

    formatTitle(title) {
      const keywordTrad = this.searchKeywordTrad;
      if (keywordTrad  && this.currentCategory != '正文') {
        const regex = new RegExp(keywordTrad, 'g')
        title = title.replace(regex, '<span class="keyword-highlight">$&</span>')
      }

      const keyword = this.currentKeyword
      if (keyword  && this.currentCategory != '正文') {
        const regex = new RegExp(keyword, 'g')
        return title.replace(regex, '<span class="keyword-highlight">$&</span>')
      }
      return title
    },
    // 输入简体字变化为繁体字，一起简体和繁体搜索的代码实现********************************end

    formatPrice(price) {
      return price.toFixed(2)
    },
    toggleMobileCategories() {
      this.showMobileCategories = !this.showMobileCategories
      if (this.isMobile) {
        this.$message({
          message: '书籍分类功能（原左侧分类菜单）已整合到搜索分类标签中，请点击搜索标签进行筛选',
          type: 'info'
        })
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.GetSearchBook();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.GetSearchBook();
      }
    },
    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page;
        this.GetSearchBook();
      }
    },
    // 返回上级界面
    goBackPage(){
      this.$router.go(-1)
    },

    handleBookClick(book) {
      // 如果搜索到正文有关键字，则点击搜索结果的书籍跳转到正文有关键字的页码正文。如果搜索正文没有关键字，则跳转到书籍简介页面
      if(book.bookpageno == '0'){
        this.$router.push({
          path: '/singlebook',
          query: { type: book.id, bookname:book.title }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
      else{
        // 20260212,如果为手机则不进入阅读界面,进入内容简介页面
        if(this.isMobile){
          this.$router.push({
            path: '/singlebook',
            query: { type: book.id, bookname:book.title }
          }).then(() => {
            window.scrollTo(0, 0)
          })
        }
        else{
          this.$router.push({
            path: '/vipread',
            query: { type: book.id, twotype: book.bookpartid, bookname:book.title, pagenoint:book.pagenoint }
          }).then(() => {
            window.scrollTo(0, 0)
          })
        }
      }
    },

  }
}
</script>

<style scoped>
/* 引入外部字体和图标库 20260105*/
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
@import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=Noto+Serif+SC:wght@400;600;700&display=swap');

/* 基础样式重置与古典风格定义 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Noto Serif SC', serif;
  line-height: 1.6;
  color: #5c3a21;
  background-color: #f5f0e6;
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C8B7E' fill-opacity='0.08' fill-rule='evenodd'/%3E%3C/svg%3E");
  min-height: 100vh;
  overflow-x: hidden;
}

.container {
  width: 100%;
  /* max-width: 1200px; 20260107，增加界面的宽度*/
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 古典风格边框与阴影 */
.classic-border {
  border: 1px solid #c9b18b;
  border-radius: 3px;
  box-shadow: 0 4px 8px rgba(92, 58, 33, 0.1);
}

.classic-bg {
  background-color: #fffaf0;
  border: 1px solid #d4c4a8;
}

/* 第一区域：顶部公司信息 */
.header-section {
  background-color: #8b4513;
  color: #f5deb3;
  padding: 19px 0;
  border-bottom: 3px solid #d2691e;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.logo-area {
  display: flex;
  align-items: center;
}

.logo {
  width: 60px;
  height: 60px;
  background-color: #f5deb3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  border: 2px solid #d2691e;
}

.logo i {
  font-size: 2rem;
  color: #8b4513;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.site-name h1 {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #f5deb3;
  letter-spacing: 2px;
  text-shadow: 1px 1px 2px #5c3a21;
}

.site-name h1 span{
  font-size: 1.6rem;
}
.english-part {
  display: inline-flex;
  align-items: flex-end; /* 确保MoKu和∞底部对齐 */
}
.moku {
  font-family: 'Noto Serif SC', serif;
  font-weight: 700;
}
.infinity {
  font-size: 1.2em; /* 稍微调整∞的大小 */
  margin-left: 2px; /* 添加一点间距 */
  line-height: 1; /* 防止行高影响对齐 */
}

.site-name p {
  font-size: 0.9rem;
  color: #e6d3b3;
  margin-top: 3px;
  font-family: 'Noto Serif SC', serif;
}

.contact-info {
  text-align: right;
}

.contact-info p {
  margin-bottom: 5px;
  font-size: 0.95rem;
  text-align: right; /* 确保每个段落都右对齐 */
  font-family: 'Noto Serif SC', serif;
}

/* 第二区域：全站搜索区 */
.search-section {
  padding: 25px 0;
  background-color: #D7B974;
  border-bottom: 2px dashed #8b4513;
}

.search-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.search-box {
  display: flex;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
}

.search-icon {
  background-color: #8b4513;
  color: #f5deb3;
  padding: 15px 20px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.search-input >>> .el-input__inner {
  flex: 1;
  padding: 18px;
  border: 1px solid #c9b18b;
  border-left: none;
  border-right: none;
  font-size: 1rem;
  font-family: 'Noto Serif SC', serif;
  background-color: #fffaf0;
  color: #5c3a21;
  min-width: 0;
  height: 100%;
  border-radius: 0;
}

.search-input >>> .el-input__inner::placeholder {
  color: #8b4513;
}

.search-input >>> .el-input__wrapper {
  padding: 0;
  border: none;
  border-radius: 0;
  background-color: #fffaf0;
  box-shadow: none;
}

.search-button {
  background-color: #a0522d;
  color: #f5deb3;
  border: none;
  padding: 0 25px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-family: 'Noto Serif SC', serif;
  font-weight: 600;
  transition: background-color 0.3s;
  flex-shrink: 0;
  height: auto;
}

.search-button:hover {
  background-color: #8b4513;
}

.search-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  max-width: 900px;
}

.search-tag {
  background-color: #fffaf0;
  border: 1px solid #c9b18b;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 0.9rem;
  color: #5c3a21;
  cursor: pointer;
  transition: all 0.3s;
  font-family: 'Noto Serif SC', serif;
}

.search-tag:hover {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
}

/* 第三区域：搜索结果区 */
.main-section {
  padding: 30px 0 40px;
  background-color: #D7B974;
  border-top: 2px dashed #8b4513;
}

/* 左侧：移动端书籍分类折叠按钮 */
.mobile-categories-toggle {
  display: none;
  width: 100%;
  background-color: #a0522d;
  color: #f5deb3;
  border: 1px solid #8b4513;
  border-radius: 5px;
  padding: 12px 15px;
  font-family: 'Noto Serif SC', serif;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 15px;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s;
  border: none;
}

.mobile-categories-toggle:hover {
  background-color: #8b4513;
}

.toggle-icon {
  font-size: 1.2rem;
  transition: transform 0.3s;
}

.toggle-icon.expanded {
  transform: rotate(90deg);
}

/* 搜索结果标题区域 */
.search-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fffaf0;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #c9b18b;
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
  margin-bottom: 25px;
}

.search-result-header-left {
  display: flex;
  align-items: center;
}

.search-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #8b4513;
  letter-spacing: 2px;
}

.search-keyword {
  color: #d32f2f;
  font-weight: 700;
}

.search-count {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.2rem;
  color: #a0522d;
  font-weight: 600;
  background-color: #f9f5eb;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #c9b18b;
}

/* 搜索结果列表样式 */
.search-results-container {
  background-color: #fffaf0;
  padding: 30px;
  border-radius: 5px;
  border: 1px solid #c9b18b;
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
}

.search-result-item {
  display: flex;
  padding: 20px;
  margin-bottom: 25px;
  border-bottom: 1px dashed #d4c4a8;
  transition: all 0.3s;
}

.search-result-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.search-result-item:hover {
  background-color: #f9f5eb;
  border-radius: 5px;
}

.book-cover-result {
  width: 160px;
  height: 224px;
  background-color: #e6d3b3;
  margin-right: 25px;
  border-radius: 3px;
  overflow: hidden;
  border: 1px solid #c9b18b;
  box-shadow: 0 3px 6px rgba(92, 58, 33, 0.1);
  flex-shrink: 0;
}

.book-cover-result img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.book-info {
  flex: 1;
  font-family: 'Noto Serif SC', serif;
}

.book-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.book-name {
  font-size: 1.3rem;
  font-weight: 700;
  color: #5c3a21;
}

.keyword-highlight {
  color: #d32f2f;
  font-weight: 700;
}

.keyword-count {
  background-color: #a0522d;
  color: #f5deb3;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.9rem;
  font-weight: 600;
}

/* 新添加的样式用于三行两列布局 */
.book-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 20px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px dotted #d4c4a8;
}

.meta-item {
  display: flex;
  align-items: center;
}

.meta-label {
  font-weight: 600;
  color: #8b4513;
  margin-right: 8px;
  white-space: nowrap;
}

.meta-value {
  color: #5c3a21;
  flex: 1;
}

.right-align {
  justify-content: flex-start;
}

.price {
  font-weight: 700;
  color: #a0522d;
  font-size: 1.1rem;
}

/* 强制两行描述 */
.two-line-description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 1.7;
  max-height: 3.4em;
  color: #5c3a21;
}

/* 分页样式 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid #d4c4a8;
  font-family: 'Noto Serif SC', serif;
}

.pagination-list {
  display: flex;
  list-style: none;
  gap: 8px;
}

.pagination-item {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  border-radius: 3px;
  color: #5c3a21;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s;
}

.pagination-item:hover {
  background-color: #f0e6d2;
  border-color: #a0522d;
}

.pagination-item.active {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
  font-weight: 700;
}

.pagination-prev,
.pagination-next {
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  border-radius: 3px;
  color: #5c3a21;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s;
  margin: 0 10px;
}

.pagination-prev:hover,
.pagination-next:hover {
  background-color: #f0e6d2;
  border-color: #a0522d;
}

.pagination-prev.disabled,
.pagination-next.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-prev.disabled:hover,
.pagination-next.disabled:hover {
  background-color: #f9f5eb;
  border-color: #c9b18b;
}

/* 第四区域：页脚 */
.footer-section {
  background-color: #5c3a21;
  color: #e6d3b3;
  padding: 25px 0;
  border-top: 3px solid #8b4513;
}

.footer-info {
  text-align: center;
  line-height: 1.8;
}

.footer-info p {
  margin-bottom: 8px;
  font-size: 0.95rem;
  font-family: 'Noto Serif SC', serif;
}

/* 弹出层样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fffaf0;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 80vh;
  overflow-y: auto;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: 2px solid #c9b18b;
  position: relative;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #d4c4a8;
}

.modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #8b4513;
  letter-spacing: 1px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #8b4513;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: rgba(139, 69, 19, 0.1);
}

.modal-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 25px;
}

.modal-tag {
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 1rem;
  color: #5c3a21;
  cursor: pointer;
  transition: all 0.3s;
  flex: 1;
  min-width: 200px;
  text-align: center;
}

.modal-tag:hover {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
  transform: translateY(-2px);
}

/* 关键词高亮样式 */
.keyword-highlight {
  color: #d32f2f !important; /* 纯红色 */
  /* background-color: rgba(255, 0, 0, 0.1) !important; 浅红色背景，该效果去掉 */
  font-weight: 700 !important;
  /* padding: 1px 3px !important; */
  border-radius: 2px !important;
}

/* 在搜索结果项中确保高亮生效 */
.book-info >>> .keyword-highlight {
  color: #d32f2f !important;
  /* background-color: rgba(255, 0, 0, 0.1) !important; 浅红色背景，该效果去掉 */
  font-weight: 700 !important;
  /* padding: 1px 3px !important; */
  border-radius: 2px !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .search-result-item {
    padding: 18px;
  }
  
  .book-cover-result {
    width: 140px;
    height: 196px;
    margin-right: 20px;
  }
}

@media (max-width: 992px) {
  .search-result-item {
    padding: 16px;
  }
  
  .book-cover-result {
    width: 130px;
    height: 182px;
    margin-right: 18px;
  }
  
  .book-name {
    font-size: 1.2rem;
  }
  
  .modal-content {
    width: 95%;
    padding: 20px;
  }
  
  .modal-tag {
    min-width: 150px;
  }
  
  .search-count {
    font-size: 1.1rem;
    padding: 7px 14px;
  }
}

@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .contact-info {
    text-align: left;
    margin-top: 15px;
  }
  
  .site-name h1 {
    font-size: 1.5rem;
  }
  
  /* 搜索框不换行 */
  .search-box {
    flex-direction: row;
    overflow: hidden;
  }
  
  .search-icon, .search-input, .search-button {
    border-radius: 0;
    border: 1px solid #c9b18b;
    margin: 0;
    width: auto;
    flex-shrink: 0;
  }

  .search-icon {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    text-align: center;
    padding: 15px;
    width: 50px;
  }

  /* 20260108,中间输入框自动延展占据剩余宽度空间。此处设置后，下面更小宽度页码的也生效 */
  .search-input {
      flex: 1;         /* 关键：占据剩余空间 */
      min-width: 0;    /* 允许缩小 */
  }
  
  .search-input >>> .el-input__inner {
    flex: 1;
    min-width: 0;
    border-left: none;
    border-right: none;
    padding: 15px 10px;
  }
  
  .search-button {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 15px 20px;
    white-space: nowrap;
  }
  
  .search-tags {
    gap: 8px;
  }
  
  .search-tag {
    padding: 6px 12px;
    font-size: 0.85rem;
  }
  
  /* 手机端保持与PC一致的布局 */
  .search-result-item {
    flex-direction: row;
    padding: 15px;
    align-items: flex-start;
  }
  
  .book-cover-result {
    width: 100px;
    height: 140px;
    margin-right: 15px;
    margin-bottom: 0;
    flex-shrink: 0;
  }
  
  .book-title-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .keyword-count {
    align-self: flex-start;
  }
  
  /* 响应式调整三行两列布局 */
  .book-meta-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .right-align {
    justify-content: flex-start;
  }
  
  .meta-item {
    flex-wrap: wrap;
  }
  
  .meta-label {
    min-width: 70px;
  }
  
  .modal-content {
    width: 98%;
    padding: 15px;
  }
  
  .modal-tags {
    gap: 10px;
  }
  
  .modal-tag {
    min-width: 120px;
    padding: 10px 15px;
    font-size: 0.9rem;
  }
  
  .modal-title {
    font-size: 1.5rem;
  }
  
  /* 20260108,修改字体 */
  .search-title {
    font-size: 1.0rem;
  }
  
  .search-count {
    font-size: 1rem;
    padding: 6px 12px;
  }
  
  /* 移动端书籍分类样式 */
  .mobile-categories-toggle {
    display: flex;
  }
  
  /* 分页响应式 */
  .pagination-list {
    gap: 5px;
  }
  
  .pagination-item {
    width: 35px;
    height: 35px;
    font-size: 0.85rem;
  }
  
  .pagination-prev,
  .pagination-next {
    width: 70px;
    height: 35px;
    font-size: 0.85rem;
    margin: 0 5px;
  }

  /* 20260108 add */
  /* .search-result-header {
    padding: 20px 5px;
  } */
  /* .search-results-container {
    padding: 20px 20px;
  } */
}

@media (max-width: 576px) {
  .site-name h1 {
    font-size: 1.3rem;
  }
  
  .logo {
    width: 50px;
    height: 50px;
  }
  
  .logo i {
    font-size: 1.5rem;
  }
  
  .contact-info p {
    font-size: 0.85rem;
  }
  
  /* 20260108,修改字体 */
  .search-title {
    font-size: 1.0rem;
  }
  
  .search-count {
    font-size: 0.9rem;
    padding: 5px 10px;
  }
  
  /* 20260108，修改图片宽度 */
  /* .book-cover-result {
    width: 90px;
    height: 126px;
    margin-right: 12px;
  } */
  .book-cover-result {
    width: 100px;
    height: 140px;
    margin-right: 12px;
  }
  
  .book-name {
    font-size: 1.1rem;
  }
  
  .book-meta-grid {
    grid-template-columns: 1fr;
  }
  
  .meta-label {
    font-size: 0.9rem;
  }
  
  .meta-value {
    font-size: 0.9rem;
  }
  
  .price {
    font-size: 1rem;
  }
  
  .footer-info p {
    font-size: 0.85rem;
  }
  
  .modal-tag {
    min-width: 100%;
  }
  
  /* 手机上进一步优化搜索框 */
  .search-icon {
    width: 45px;
    padding: 12px;
  }
  
  .search-button {
    padding: 12px 15px;
    font-size: 0.9rem;
  }
  
  .search-input >>> .el-input__inner {
    padding: 12px 8px;
    font-size: 0.9rem;
  }
  
  /* 书籍容器内边距 */
  .search-results-container {
    padding: 20px 0px;
  }
  
  /* 移动端搜索结果标题布局调整为垂直 */
  .search-result-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .search-result-header-left {
    width: 100%;
  }
  
  .search-count {
    align-self: flex-end;
    margin-top: -10px;
  }
  
  /* 分页进一步调整 */
  .pagination-list {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 400px) {
  /* 超小屏幕搜索结果优化 */
  .search-result-item {
    padding: 12px;
    flex-direction: column;
    align-items: center;
  }
  
  /* 修改手机上图片的宽度 */
  /* .book-cover-result {
    width: 100%;
    height: 200px;
    margin-right: 0;
    margin-bottom: 15px;
  } */
  .book-cover-result {
    width: 100px;
    height: 140px;
    margin-right: 15px;
    margin-bottom: 0;
    flex-shrink: 0;
  }
  
  .book-name {
    font-size: 1rem;
  }
  
  .book-meta-grid {
    grid-template-columns: 1fr;
  }
  
  .meta-label, .meta-value {
    font-size: 0.85rem;
  }
  
  /* 超小屏幕搜索框优化 */
  .search-icon {
    width: 40px;
    padding: 10px;
    font-size: 1rem;
  }
  
  .search-button {
    padding: 10px 12px;
    font-size: 0.85rem;
  }
  
  .search-input >>> .el-input__inner {
    padding: 10px 6px;
    font-size: 0.85rem;
  }
  
  /* 分页简化 */
  .pagination-list {
    gap: 3px;
  }
  
  .pagination-item {
    width: 30px;
    height: 30px;
    font-size: 0.8rem;
  }
  
  .pagination-prev,
  .pagination-next {
    width: 60px;
    height: 30px;
    font-size: 0.8rem;
    margin: 0 3px;
  }

  /* .search-result-header {
    padding: 20px 5px;
  } */
  /* .search-results-container {
    padding: 20px 0px;
  } */
  
}

/* PC端书籍简介显示3行 */
@media (min-width: 769px) {
  .two-line-description {
    -webkit-line-clamp: 2;
    max-height: 3.4em;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/searchpage/index.vue